module.exports = __webpack_public_path__ + "static/media/rad1.d19b3cd7.svg";